import Box from 'components/shared/Box'
import styled, { css } from 'styled-components'
import { respondBelow } from 'styles/mediaQueries'
import { applyThickLeftBorder } from 'styles/mixins'

interface FamilyCheckboxWrapperProps {
    isChecked: boolean
    isDarkMode?: boolean
}

export const FamilyCheckboxWrapper = styled(Box)<FamilyCheckboxWrapperProps>`
    position: relative;
    background-color: ${({ theme, isDarkMode }) =>
        isDarkMode ? theme.colors.grayscale_900 : theme.colors.grayscale_100};
    padding: 24px;
    border-radius: 8px;
    border: ${({ theme, isDarkMode }) =>
        `2px solid ${
            isDarkMode ? theme.colors.darkmode_500 : theme.colors.grayscale_400
        }`};

    ${({ isChecked, isDarkMode }) =>
        isChecked &&
        css`
            background-color: ${({ theme }) =>
                isDarkMode
                    ? theme.colors.darkmode_500
                    : theme.colors.grayscale_0};
            border: 2px solid ${({ theme }) => theme.colors.primary_500};
            ${isDarkMode && applyThickLeftBorder(isDarkMode)}
        `};

    ${({ isDarkMode }) =>
        !isDarkMode &&
        css`
            &:hover,
            &:focus-within {
                background-color: ${({ theme }) => theme.colors.grayscale_200};
                border-color: ${({ theme }) => theme.colors.grayscale_400};
            }
        `}

    @media ${respondBelow.xl} {
        padding: 16px;
    }
`
